/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';
import Thread, { IThread, IThreadJSON } from '../descriptors/commentsthreaddescriptor';

export interface IConnectResponse extends IMessage {
	channel: string;
	threads?: string[];
	threadsV2?: IThreadJSON[];
}

export default class ConnectResponse extends Message {
	public readonly threads: IThread[];

	public static readonly DESCRIPTOR_NAME: string = 'CommentsV2ConnectResponse';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			channel: {
				type: 'string',
				id: 1
			},
			threads: {
				type: 'string',
				rule: 'repeated',
				id: 2
			},
			threadsV2: {
				type: 'CommentsThreadDescriptor',
				rule: 'repeated',
				id: 3
			}
		}
	};

	public constructor(
		public readonly channel: string,
		private readonly _threads?: IThread[],
		private readonly _threadsV2?: IThread[]
	) {
		super();

		this.threads = _threadsV2?.length ? _threadsV2! : _threads!;
	}

	public toJSON(): IConnectResponse {
		return {
			channel: this.channel,
			threads: this._threads?.map( thread => JSON.stringify( thread ) ),
			threadsV2: this._threadsV2?.map( Thread.toJSON )
		};
	}

	public static fromJSON( object: IConnectResponse ): ConnectResponse {
		return new ConnectResponse(
			object.channel,
			object.threads?.map( thread => JSON.parse( thread ) ),
			object.threadsV2?.map( Thread.fromJSON )
		);
	}
}
